<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <h1>Datenschutz</h1>

        <ol>
          <h2>Einleitung und Begriffe</h2>
          <li>
            <h3>Allgemein</h3>
            Mit dem Betrieb unserer Webseite mit der URL www.lauf-gegen-rechts.de (im Folgenden „Webseite“ genannt)
            verarbeiten wir personenbezogene Daten. Diese werden von uns vertraulich behandelt und nach den geltenden
            Gesetzen – insbesondere der Datenschutzgrundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG) –
            verarbeitet. Mit diesen Datenschutzbestimmungen wollen wir Sie darüber informieren, welche personenbezogenen
            Daten wir von Ihnen erheben, zu welchen Zwecken und auf welcher Rechtsgrundlage wir sie verwenden und
            gegebenenfalls wem wir sie offenlegen. Darüber hinaus werden wir Ihnen erklären, welche Rechte Ihnen zur
            Wahrung und Durchsetzung Ihres Datenschutzes zustehen.Mit dem Betrieb unserer Webseite mit der URL
            www.lauf-gegen-rechts.de (im Folgenden „Webseite“ genannt) verarbeiten wir personenbezogene Daten. Diese
            werden von uns vertraulich behandelt und nach den geltenden Gesetzen – insbesondere der
            Datenschutzgrundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG) – verarbeitet. Mit diesen
            Datenschutzbestimmungen wollen wir Sie darüber informieren, welche personenbezogenen Daten wir von Ihnen
            erheben, zu welchen Zwecken und auf welcher Rechtsgrundlage wir sie verwenden und gegebenenfalls wem wir sie
            offenlegen. Darüber hinaus werden wir Ihnen erklären, welche Rechte Ihnen zur Wahrung und Durchsetzung Ihres
            Datenschutzes zustehen.Mit dem Betrieb unserer Webseite mit der URL www.lauf-gegen-rechts.de (im Folgenden
            „Webseite“ genannt) verarbeiten wir personenbezogene Daten. Diese werden von uns vertraulich behandelt und
            nach den geltenden Gesetzen – insbesondere der Datenschutzgrundverordnung (DSGVO) und des
            Bundesdatenschutzgesetzes (BDSG) – verarbeitet. Mit diesen Datenschutzbestimmungen wollen wir Sie darüber
            informieren, welche personenbezogenen Daten wir von Ihnen erheben, zu welchen Zwecken und auf welcher
            Rechtsgrundlage wir sie verwenden und gegebenenfalls wem wir sie offenlegen. Darüber hinaus werden wir Ihnen
            erklären, welche Rechte Ihnen zur Wahrung und Durchsetzung Ihres Datenschutzes zustehen.
          </li>
          <li>
            <h3>Begriffe</h3>
            Unsere Datenschutzbestimmungen enthalten Fachbegriffe, die in der DSGVO und dem BDSG-neu stehen. Zu
            Ihrem besseren Verständnis wollen wir diese Begriffe in einfachen Worten vorab erklären:
            <ol>
              <li>
                <h4>Personenbezogene Daten</h4>
                „Personenbezogene Daten“ sind alle Informationen, die sich auf eine identifizierte oder identifizierbare
                Person beziehen (Art. 4 Nr. 1 DSGVO). Angaben einer identifizierten Person können z. B. der Name oder
                die E-Mail-Adresse sein. Personenbezogen sind aber auch Daten, bei denen die Identität nicht unmittelbar
                ersichtlich ist, sich aber ermitteln lässt, indem man eigene oder fremde Informationen kombiniert und so
                erfährt um wen es sich handelt. Eine Person wird z. B. über die Angabe Ihrer Anschrift oder
                Bankverbindung, Ihres Geburtsdatums oder Benutzernamens, Ihrer IP-Adressen und/oder Standortdaten
                identifizierbar. Relevant sind hier alle Informationen, die in irgendeiner Weise einen Rückschluss auf
                eine Person zulassen.
              </li>
              <li>
                <h4>Verarbeitung</h4>
                Unter einer „Verarbeitung“ versteht Art. 4 Nr. 2 DSGVO jeden Vorgang im Zusammenhang mit
                personenbezogenen Daten. Dies betrifft insbesondere das Erheben, das Erfassen, die Organisation, das
                Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen, die Verwendung,
                die Offenlegung, Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich
                oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung von personenbezogenen
                Daten.
              </li>
            </ol>
          </li>
          <h2>Verantwortliche und Datenschutzbeauftragte</h2>
          <li>
            <h4>Verantwortliche</h4>
            Verantwortlich für die Datenverarbeitung ist:<br/>
            Verein: Fußball-Club St. Pauli v. 1910 e.V. (Abteilung Marathon)<br/>
            Gesetzliche Vertreter*in: Oke Göttlich (Präsident), Christiane Hollander, Esin Rager, Carsten Höltkemeyer, Jochen Winand (Vizepräsident*innen)<br/>
            Anschrift: Harald-Stender-Platz 1, 20359 Hamburg<br/>
            Telefon: 040 – 31 78 74 0<br/>
            E-Mail: abteilungsleitung@fcstpauli-marathon.de<br/>
          </li>
          <li>
            <h4>Datenschutzbeauftragte</h4>
            Wir haben für unseren Verein eine externen Datenschutzbeauftragte bestellt. Sie erreichen diese unter:<br/>
            Unternehmen: HABEWI GmbH & Co. KG<br/>
            Gesetzliche Vertreterin: Komplementärin HABEWI GmbH,<br/>
            diese vertreten durch den Geschäftsführer Arne Platzbecker<br/>
            Anschrift: Palmaille 96, 22767 Hamburg<br/>
            Telefon: 040/ 18189800<br/>
            Fax: 040/ 181898099<br/>
            E-Mail: datenschutz@habewi.de<br/>
          </li>
          <li>
            <h4>Verarbeitungsrahmen</h4>
            Im Rahmen der Webseite verarbeiten wir die nachfolgend im Abschnitt IV. im Einzelnen aufgeführten
            personenbezogenen Daten von Ihnen. Wir verarbeiten nur Daten von Ihnen, die Sie aktiv auf der Webseite
            angeben (insb. durch das Ausfüllen von Formularen) zur Verfügung stellen.
            Ihre Daten werden ausschließlich von uns verarbeitet und grundsätzlich nicht an Dritte verkauft, verliehen
            oder weitergegeben. Sofern wir uns bei der Verarbeitung Ihrer personenbezogenen Daten der Hilfe externer
            Dienstleister bedienen, erfolgt dies im Rahmen einer sogenannten Auftragsverarbeitung, bei der wir als
            Auftraggeber unseren Auftragnehmern gegenüber weisungsbefugt sind. Zum Betrieb unserer Webseite setzen wir
            für das Hosting, sowie zur Pflege, Wartung und Weiterentwicklung unser Mitglied Christoph Kluenter als
            externen Dienstleister ein. Wir hosten unsere Webseite im Rechenzentrumsstandort Hamburg, Deutschland.
            Sollten bei einzelnen, der in Abschnitt IV. aufgeführten Verarbeitungen weitere externe Dienstleister zum
            Einsatz kommen, werden sie dort benannt.
            Eine Datenübermittlung in Drittstaaten findet durch uns grundsätzlich nicht statt und ist auch nicht
            geplant. Über Ausnahmen von diesem Grundsatz werden wir in den nachfolgend dargestellten Verarbeitungen
            informieren. Eine etwaige Datenübermittlung in Drittstaaten erfolgt dann auf Grundlage der sogenannten
            EU-Standardvertragsklauseln.

          </li>
          <h3>Die VERARBEITUNGEN Im Einzelnen</h3>
          <li>
            <h4>Anmeldung zum Lauf gegen Rechts</h4>
            <ol>
              <li>
                <h5>Beschreibung der Verarbeitung</h5>
                Um beim virtuellen „Lauf gegen Rechts“ 2026 teilnehmen zu können, müssen Sie sich vorher anmelden. Die
                Registrierung erfolgt, indem Sie das Anmeldeformular auf unserer Webseite ausfüllen und uns elektronisch
                übermitteln. Zur Anmeldung bedarf es keinerlei Pflichtangaben. Sie können freiwillig entscheiden, ob Sie
                Ihren Vornamen, Nachnamen, E-Mail-Adresse, Geburtsjahr und/oder den Namen Ihres Teams angeben wollen.
                Weiterhin können Sie eine Auswahl, treffen ob und in welcher Höhe Sie für … spenden möchten. Schließlich
                können Sie im Rahmen Ihrer Anmeldung angeben, ob und in welcher Größe, sowie Ausführung (Tailliert,
                Unisex) Sie ein Laufshirt für 15 Euro erwerben wollen. Damit wir Ihnen das T-Shirt per Post zusenden
                können, bedarf es auch der Angabe Ihrer Anschrift. Mit dem Anklicken des Buttons „Absenden“ übermitteln
                Sie uns das Formular. Ihnen wird dann im Anschluss auf unserer Webseite mitgeteilt, dass Ihre Anmeldung
                erfolgreich war und welche Startnummer Ihnen durch unser System vergeben worden ist. Darüber hinaus wird
                ein für Sie generierter Link ausgegeben, unter dem Sie Ihre persönlichen Angaben und erteilten
                Einwilligungen verwalten können. Etwaige Zahlungen sind von Ihnen dann per Überweisung vorzunehmen. Zur
                Abwicklung der Lieferung des T-Shirts werden wir Ihren Vornamen, Nachnamen und Ihre Anschrift an DHL als
                Versanddienstleister übermitteln.
                Beim Versand ins Europäische Ausland erheben wir 2 Euro Versandgebühren.
                <h5>Gutscheincode</h5>
                Wenn Sie beim Anmelden einen Ihnen zugestellten Gutscheincode verwenden, speichern wir zusätzlich welchen Gutscheincode Sie
                verwendet haben.
                <h5>Anmelden für den Lauf um die Alster</h5>
                Wenn Sie an unserer vor-Ort Veranstaltung teilnehmen wollen, müssen Sie zusätzlich angeben in welchem Tempo
                Sie mitlaufen wollen.
                Nach dem Lauf haben Sie die Möglichkeit eine Urkunde mit Ihrem Namen und Ihrer gelaufenen Zeit runterzuladen.
                Hierzu geben Sie Ihre Zeit ein und es wird eine Urkunde im PDF Format generiert. Hierzu speichern wir die von Ihnen
                angegebe Zeit.
              </li>
              <li>
                <h5>Zweck</h5>
                Die Verarbeitung erfolgt, um Ihnen die Anmeldung beim virtuellen „Lauf gegen Rechts“ 2026 ermöglichen zu
                können. Die Verarbeitung im Zusammenhang mit dem Erwerb eines Laufshirts erfolgt zum Abschluss und zur
                Abwicklung von Kaufverträgen.
              </li>
              <li>
                <h5>Rechtsgrundlage</h5>
                Die Verarbeitung Ihrer Anmelderangaben (Vorname, Nachname, E-Mail-Adresse, Name des Teams) erfolgt auf
                Grundlage einer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Ihre Einwilligung ist freiwillig. Die
                Verarbeitung Ihrer Angaben zum Laufshirt (Kaufentscheidung, Größe, Modell) ist zum Abschluss und zur
                Erfüllung des Kaufvertrages erforderlich (Art. 6 Abs. 1 lit. b DSGVO). Letzteres betrifft auch die
                Übermittlung der zur Lieferung des T-Shrits erforderlichen Daten an den Versanddienstleister DHL.
              </li>
              <li>
                <h5>Speicherdauer</h5>
                Die von Ihnen bei der Anmeldung angegebenen Daten werden 4 Monate nach der Veranstaltung automatisch
                gelöscht. Diesbezüglich können Sie Ihre Einwilligung auch jederzeit widerrufen. Dafür genügt eine
                einfache Erklärung per E-Mail an info@lauf-gegen-rechts.de oder per Post an Fußball-Club St. Pauli v.
                1910 e.V. (Abteilung Marathon), Harald-Stender-Platz 1, 20359 Hamburg. Sie können Ihre Daten im Übrigen
                jederzeit selbst unter dem in Ziffer 6.1 genannten persönlichen Link bearbeiten, ergänzen oder löschen.
                Im Hinblick auf einen T-Shirt-Kauf sind wir aufgrund von handels- und steuerrechtlichen Vorgaben
                verpflichtet, Ihre Adress-, Zahlungs- und Bestelldaten für die Dauer von zehn Jahren zu speichern.
                Allerdings nehmen wir nach zwei Jahren eine Einschränkung der Verarbeitung vor. D.h. Ihre Daten werden
                dann nur noch zur Einhaltung der gesetzlichen Aufbewahrungsfristen gesondert aufbewahrt und nach deren
                Ablauf unverzüglich gelöscht.
              </li>
              <li>
                <h5>Empfänger</h5>
                Zur Durchführung und Abwicklung der Warenlieferung werden wir die dafür erforderlichen Daten an den
                Versanddienstleister DHL (DHL Paket GmbH, Sträßchenweg 10, 53113 Bonn) weitergeben.
              </li>
            </ol>
          </li>
          <li>
            <h4>Kontaktaufnahme per E-Mail</h4>
            <ol>
              <li>
                <h5>Beschreibung der Verarbeitung</h5>
                Zur Kontaktaufnahme können Sie uns über die auf der Webseite angegebene E-Mail-Adresse anschreiben. In
                diesem Fall werden die mit der E-Mail übermittelten personenbezogenen Daten durch uns verarbeitet.
              </li>
              <li>
                <h5>Zweck</h5>
                Die mit und in Ihrer E-Mail übermittelten Daten werden ausschließlich zum Zwecke der Bearbeitung und
                Beantwortung Ihres Anliegens verwendet.
              </li>
              <li>
                <h5>Rechtsgrundlage</h5>
                Die Verarbeitung ist zur Wahrung der überwiegenden berechtigten Interessen des Verantwortlichen
                erforderlich (Art. 6 Abs. 1 lit. f DSGVO). Unser berechtigtes Interesse liegt in dem, in Ziffer 7.1
                benannten Zweck. Sofern der E-Mail-Kontakt auf den Abschluss oder der Erfüllung eines Vertrages abzielt,
                so erfolgt die Datenverarbeitung zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).
              </li>
              <li>
                <h5>Speicherdauer</h5>
                Die Daten werden von uns gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
                erforderlich sind. Dies ist für gewöhnlich der Fall, wenn die jeweilige Kommunikation mit Ihnen beendet
                ist. Beendet ist die Kommunikation dann, wenn sich aus den Umständen entnehmen lässt, dass Ihr Anliegen
                abschließend geklärt ist. Sofern gesetzliche Aufbewahrungsfristen einer Löschung entgegenstehen, erfolgt
                eine Löschung unverzüglich nach Ablauf der gesetzlichen Aufbewahrungsfrist.
              </li>
            </ol>
          </li>
          <li>
            <h4>Sicherheitsmassnahmen</h4>
            Um Ihre persönlichen Daten vor fremdem Zugriff zu schützen, haben wir unsere Webseite mit einem SSL- bzw.
            TLS-Zertifikat versehen. SSL steht für „Secure-Sockets-Layer“ und TLS für „Transport Layer Security“ und
            verschlüsselt die Kommunikation von Daten zwischen einer Webseite und dem Endgerät des Nutzers. Sie erkennen
            die aktive SSL- bzw. TLS-Verschlüsselung an einem kleinen Schloss-Logo, das ganz links in der Adresszeile
            des Browsers angezeigt wird.
          </li>
          <li>
            <h4>Ihre Rechte</h4>
            <ol>
              <h5>Betroffenenrechte</h5>
              Im Hinblick auf die oben beschriebene Datenverarbeitung durch unseren Verein stehen Ihnen die folgenden
              Betroffenenrechte zu:
              <li><h5>Auskunft (Art. 15 DSGVO)</h5>
                Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob wir Sie betreffende
                personenbezogene Daten verarbeiten. Ist dies der Fall, so haben sie unter den in Art. 15 DSGVO genannten
                Voraussetzungen ein Recht auf Auskunft über diese personenbezogenen Daten und auf die in Art. 15 DSGVO
                im einzelnen aufgeführten Informationen.
              </li>
              <li><h5>Berichtigung (Art. 16 DSGVO)</h5>
                Sie haben das Recht, von uns unverzüglich die Berichtigung Sie betreffender unrichtiger
                personenbezogener Daten und ggf. die Vervollständigung unvollständiger personenbezogener Daten zu
                verlangen.
              </li>
              <li><h5>Löschung (Art. 17 DSGVO)</h5>
                Sie haben das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich
                gelöscht werden, sofern einer der in Art. 17 DSGVO im Einzelnen aufgeführten Gründe zutrifft, z. B. wenn
                Ihre Daten für die von uns verfolgten Zwecke nicht mehr benötigt werden.
              </li>
              <li><h5>Einschränkung der Datenverarbeitung (Art. 18 DSGVO)</h5>
              Sie haben das Recht, von uns die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18
              DSGVO aufgeführten Voraussetzungen gegeben ist, z. B. wenn Sie die Richtigkeit Ihrer personenbezogenen
              Daten bestreiten, wird die Datenverarbeitung für die Dauer eingeschränkt, die uns die Überprüfung der
              Richtigkeit Ihrer Daten ermöglicht.
              </li>
              <li><h5>Datenübertragbarkeit (Art. 20 DSGVO)</h5>
              Sie haben das Recht, unter den in Art. 20 DSGVO aufgeführten Voraussetzungen, die Herausgabe der Sie
              betreffenden Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu verlangen.
              </li>
              <li><h5>Widerruf von Einwilligungen (Art. 7 Abs. 3 DSGVO)</h5>
              Sie haben das Recht, bei einer Verarbeitung, die auf einer Einwilligung beruht, Ihre Einwilligung
              jederzeit zu widerrufen. Der Widerruf gilt ab dem Zeitpunkt seiner Geltendmachung. Er wirkt mit anderen
              Worten für die Zukunft. Die Verarbeitung wird durch den Widerruf der Einwilligung also nicht rückwirkend
              rechtswidrig.
              </li>
              <li><h5>Beschwerde (Art. 77 DSGVO)</h5>
              Wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die
              DSGVO verstößt, haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde. Sie können dieses Recht bei
              einer Aufsichtsbehörde in dem EU-Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts
              des mutmaßlichen Verstoßes geltend machen.
              </li>
              <li><h5>Verbot automatisierter Entscheidungen/Profiling (Art. 22 DSGVO)</h5>
              Entscheidungen, die für Sie rechtliche Folge nach sich ziehen oder Sie erheblich beeinträchtigen, dürfen
              nicht ausschließlich auf eine automatisierte Verarbeitung personenbezogener Daten – einschließlich eines
              Profiling – gestützt werden. Wir teilen Ihnen mit, dass wir im Hinblick auf Ihre personenbezogenen Daten
              keine automatisierte Entscheidungsfindung einschließlich Profiling einsetzen.
              </li>
              <li><h5>Widerspruchsrecht (Art. 21 DSGVO)</h5>
              Wenn wir personenbezogene Daten von Ihnen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (zur Wahrung
              überwiegender berechtigten Interessen) verarbeiten, haben Sie das Recht, unter den in Art. 21 DSGVO
              aufgeführten Voraussetzungen dagegen Widerspruch einzulegen. Dies gilt jedoch nur, soweit Gründe
              vorliegen, die sich aus Ihrer besonderen Situation ergeben. Nach einem Widerspruch verarbeiten wir Ihre
              personenbezogenen Daten nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die
              Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen. Wir müssen die
              Verarbeitung ebenfalls nicht einstellen, wenn sie der Geltendmachung, Ausübung oder Verteidigung von
              Rechtsansprüchen dient. In jedem Fall – auch unabhängig von einer besonderen Situation – haben Sie das
              Recht, jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten für Direktwerbung
              einzulegen.
              </li>
            </ol>
          </li>
        </ol>
      </v-container>

    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'Datenschutz'
};
</script>
